var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4308 3.85791L12.305 16.8699C12.2285 17.0645 12.0926 17.2299 11.9166 17.3427C11.7406 17.4556 11.5336 17.51 11.3248 17.4983C11.1161 17.4866 10.9164 17.4094 10.7542 17.2777C10.5919 17.1459 10.4753 16.9663 10.421 16.7644L8.89408 11.1056L3.23528 9.5787C3.03342 9.52441 2.85383 9.40783 2.72207 9.24556C2.59031 9.08328 2.51309 8.88358 2.5014 8.67488C2.48971 8.46617 2.54416 8.2591 2.65698 8.08313C2.7698 7.90716 2.93525 7.77126 3.12978 7.69477L16.1418 2.56895C16.322 2.49804 16.5189 2.48128 16.7084 2.52073C16.8979 2.56018 17.0718 2.65411 17.2087 2.791C17.3456 2.92789 17.4395 3.10178 17.479 3.29131C17.5184 3.48084 17.5017 3.67777 17.4308 3.85791Z",
    fill: "#3936EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.703cfbaadd25f3285b535b42d48c2e26.svg";
export { ForwardRef as ReactComponent };